module.exports = __webpack_public_path__ + "static/img/28.43933d7d.png";